import { service } from '@maia/insurance';
import { useMutation } from '@tanstack/react-query';

type UseCreateClaimParams = Parameters<typeof service.createNote>[1];

export function useCreateInsuranceNote(
  customerGuid: string,
  insuranceGuid: string,
  onSuccess?: () => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: (args: UseCreateClaimParams) =>
      service.createNote(
        `customers/${customerGuid}/insurances/${insuranceGuid}/notes`,
        args,
      ),
    onSuccess,
    onError,
  });
}
